import { Grid, GridItem } from "@chakra-ui/react";

const Luminaires = ({ luminaires }) => {
    return (
        luminaires?.length > 0 && luminaires.map((item, index) => {
            // 1. Check if this is a lamp recommendation or a fixture recommendation
            const isLamp = item?.lampRecomendedAirtable && item.lampRecomendedAirtable.length > 0;

            // 2. Safely parse and target the correct data fields
            let targetFields = null;
            if (isLamp) {
                try {
                    targetFields = JSON.parse(item.lampRecomendedAirtable);
                } catch (e) {
                    console.error("Error parsing lamp data: ", e);
                }
            } else if (item?.fixtureRecomendedAirtableArray?.length > 0) {
                targetFields = item.fixtureRecomendedAirtableArray[0]['fields'];
            }

            const lampQty = item.recomendedLampQty ? Number(item.recomendedLampQty) : 1;
            const fixtureQty = item.qty ? Number(item.qty) : (item.recomendedFixtureQty ? Number(item.recomendedFixtureQty) : 1);

            const qty = isLamp ? (lampQty * fixtureQty) : fixtureQty;

            const customPpu = targetFields?.['SU PPU ($) Custom FE'];
            const vol1Ppu = targetFields?.['FE PPU Vol1 ($)'];
            const vol2Ppu = targetFields?.['FE PPU Vol2 ($)'];
            const standardPpu = targetFields?.['FE PPU ($)'];

            let ppu = 0;
            let ppuDisplay = '$0.00';

            if (customPpu) {
                ppu = Number(customPpu);
                ppuDisplay = '$' + customPpu;
            } else if (qty >= 100 && qty < 200) {
                ppu = Number(vol1Ppu || 1);
                ppuDisplay = '$' + ppu.toFixed(2);
            } else if (qty >= 200) {
                ppu = Number(vol2Ppu || 1);
                ppuDisplay = '$' + ppu.toFixed(2);
            } else {
                ppu = Number(parseFloat(standardPpu || 0));
                ppuDisplay = '$' + ppu.toFixed(2);
            }

            const totalPrice = ppu * qty;

            const renderExtraRow = (fields, totalQty, keySuffix) => {
                if (!fields) return null;

                const extCustomPpu = fields?.['SU PPU ($) Custom FE'];

                const cleanPpu = (val) => typeof val === 'string' ? Number(val.replace(/[^0-9.]/g, '')) : Number(val);

                const extVol1Ppu = cleanPpu(fields?.['FE PPU Vol1 ($)']);
                const extVol2Ppu = cleanPpu(fields?.['FE PPU Vol2 ($)']);
                const extStandardPpu = cleanPpu(fields?.['FE PPU ($)']);

                let exPpu = 0;
                let exPpuDisplay = '$0.00';

                if (extCustomPpu) {
                    exPpu = Number(extCustomPpu);
                    exPpuDisplay = '$' + extCustomPpu;
                } else if (totalQty >= 100 && totalQty < 200) {
                    exPpu = extVol1Ppu || 1;
                    exPpuDisplay = '$' + exPpu.toFixed(2);
                } else if (totalQty >= 200) {
                    exPpu = extVol2Ppu || 1;
                    exPpuDisplay = '$' + exPpu.toFixed(2);
                } else {
                    exPpu = extStandardPpu || 0;
                    exPpuDisplay = '$' + exPpu.toFixed(2);
                }

                const exTotalPrice = exPpu * totalQty;

                return (
                    <Grid
                        templateColumns='repeat(7, 1fr)'
                        key={`${index}-${keySuffix}`}
                        px={4}
                        border='1px solid #A9A9A9'
                        borderRadius='6px'
                        minH='64px'
                        alignItems='center'
                        mb={5}
                    >
                        <GridItem colSpan={3}>
                            {fields?.['FE Product Description'] || ''}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {fields?.['FE Order Code'] || ''}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {totalQty.toLocaleString('en-US')}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {exPpuDisplay}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {'$' + exTotalPrice.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </GridItem>
                    </Grid>
                );
            };
            let powerFields = null;
            if (item?.powerSupplyRecomendedAirtableArray?.length > 0) {
                powerFields = item.powerSupplyRecomendedAirtableArray[0]['fields'] || item.powerSupplyRecomendedAirtableArray[0];
            }
            const powerBaseQty = item.powerSupplyRecomendedQty ? Number(item.powerSupplyRecomendedQty) : (item.powerQTYFixture ? Number(item.powerQTYFixture) : 1);
            const powerQtyTotal = fixtureQty * powerBaseQty;

            let controlFields = null;
            if (item?.controlRecomendedAirtableArray?.length > 0) {
                controlFields = item.controlRecomendedAirtableArray[0]['fields'] || item.controlRecomendedAirtableArray[0];
            }
            const controlBaseQty = item.controlRecomendedQty ? Number(item.controlRecomendedQty) : 1;
            const controlQtyTotal = fixtureQty * controlBaseQty;

            let accessoryFields = null;
            if (item?.accessoryRecomendedAirtableArray?.length > 0) {
                accessoryFields = item.accessoryRecomendedAirtableArray[0]['fields'] || item.accessoryRecomendedAirtableArray[0];
            }
            const accessoryBaseQty = item.accessoryRecomendedQty ? Number(item.accessoryRecomendedQty) : 1;
            const accessoryQtyTotal = fixtureQty * accessoryBaseQty;


            return (
                <div key={index}>

                    {targetFields && (
                        <Grid
                            templateColumns='repeat(7, 1fr)'
                            px={4}
                            border='1px solid #A9A9A9'
                            borderRadius='6px'
                            minH='64px'
                            alignItems='center'
                            mb={5}
                        >
                            <GridItem colSpan={3}>
                                {targetFields?.['FE Product Description'] || ''}
                            </GridItem>

                            <GridItem colSpan={1} textAlign='center'>
                                {targetFields?.['FE Order Code'] || ''}
                            </GridItem>

                            <GridItem colSpan={1} textAlign='center'>
                                {qty.toLocaleString('en-US')}
                            </GridItem>

                            <GridItem colSpan={1} textAlign='center'>
                                {ppuDisplay}
                            </GridItem>

                            <GridItem colSpan={1} textAlign='center'>
                                {'$' + totalPrice.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </GridItem>
                        </Grid>
                    )}
                    {powerFields && renderExtraRow(powerFields, powerQtyTotal, 'power')}
                    {controlFields && renderExtraRow(controlFields, controlQtyTotal, 'control')}
                    {accessoryFields && renderExtraRow(accessoryFields, accessoryQtyTotal, 'accessory')}
                </div>
            );
        })
    );
};

export default Luminaires;